<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <button
        class="navbar-toggler d-lg-none"
        type="button"
        @click="$emit('toggle-sidebar')"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <span class="navbar-brand mb-0 h1">My Dashboard</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
};
</script>
